var _path, _g, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnmol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6587 16.2061C16.6998 16.2061 15.8267 16.2061 14.9069 16.2061C14.9069 18.085 14.9069 19.9679 14.9069 21.875C13.9558 21.875 13.0437 21.875 12.1238 21.875C12.1238 18.0409 12.1238 14.2308 12.1238 10.3766C13.0086 10.3766 13.8817 10.3766 14.7938 10.3766C14.7938 9.44923 14.7938 8.56196 14.7938 7.64258C16.6803 7.64258 18.5279 7.64258 20.391 7.64258C20.391 12.3921 20.391 17.1215 20.391 21.875C19.4867 21.875 18.6019 21.875 17.6626 21.875C17.6587 20.0001 17.6587 18.1212 17.6587 16.2061ZM17.6158 10.5051C16.6959 10.5051 15.8033 10.5051 14.9146 10.5051C14.9146 11.4606 14.9146 12.384 14.9146 13.3074C15.8267 13.3074 16.7154 13.3074 17.6158 13.3074C17.6158 12.364 17.6158 11.4406 17.6158 10.5051Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_760_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7025 6.125C13.7025 7.09256 13.7025 8.05209 13.7025 9.04776C12.7515 9.04776 11.8082 9.04776 10.8455 9.04776C10.8455 8.0802 10.8455 7.11665 10.8455 6.125C11.7887 6.125 12.7359 6.125 13.7025 6.125Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.1875 11.8662C24.1875 12.8338 24.1875 13.7933 24.1875 14.789C23.2364 14.789 22.2931 14.789 21.3304 14.789C21.3304 13.8214 21.3304 12.8579 21.3304 11.8662C22.2736 11.8662 23.2208 11.8662 24.1875 11.8662Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.8571 10.4209C10.8571 11.3885 10.8571 12.348 10.8571 13.3437C9.90601 13.3437 8.96275 13.3437 8 13.3437C8 12.3761 8 11.4125 8 10.4209C8.94326 10.4209 9.89042 10.4209 10.8571 10.4209Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.1875 16.6035C24.1875 17.5711 24.1875 18.5306 24.1875 19.5263C23.2364 19.5263 22.2931 19.5263 21.3304 19.5263C21.3304 18.5587 21.3304 17.5952 21.3304 16.6035C22.2736 16.6035 23.2208 16.6035 24.1875 16.6035Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_760_206",
    x: 0.845459,
    y: -3.875,
    width: 22.8571,
    height: 22.9229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_760_206"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_760_206",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnmol);
export default __webpack_public_path__ + "static/media/Anmol.b0309dadaea6e2ba9f4b8ec273c50878.svg";
export { ForwardRef as ReactComponent };